import { render } from "./VaPageNotFoundSimple.vue?vue&type=template&id=1f1290d5"
import script from "./VaPageNotFoundSimple.vue?vue&type=script&lang=js"
export * from "./VaPageNotFoundSimple.vue?vue&type=script&lang=js"

import "./VaPageNotFoundSimple.vue?vue&type=style&index=0&id=1f1290d5&lang=scss"
script.render = render

export default script